.fdi.wc.container{
  .titleContainer{
    width: 100%;
    .collapseTrigger{
      padding: 0 5px;
      &:hover{
        cursor: pointer;
      }
    }
  }
  .menu{
    width: 100%;
    ul{
      li{
        display: inline-block;
        margin-right: 10px;
        padding: 5px;
        &:hover{
          background: #ececec;
          cursor: pointer;
        }
      }
    }
  }
  .content{
    width: 100%;
  }
}
